/* eslint-disable prefer-template */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-return-assign */
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';

function AppTopbarMenu() {
  const { t } = useTranslation();
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRefs = useRef({});

  useEffect(() => {
    function handleClickOutside(event) {
      const isClickInsideAny = Object.values(dropdownRefs.current).some(
        (ref) => ref && ref.contains(event.target)
      );
      if (!isClickInsideAny) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function isActive(pathOrPaths) {
    if (Array.isArray(pathOrPaths)) {
      return pathOrPaths.some(
        (path) => location.pathname === path || location.pathname.startsWith(path + '/')
      );
    }
    return location.pathname === pathOrPaths || location.pathname.startsWith(pathOrPaths + '/');
  }

  function isDropdownActive(item) {
    if (item.children) {
      return item.children.some((child) => isActive(child.to));
    }
    return isActive(item.activePaths || item.to);
  }

  const model = [
    {
      label: t('menu.home.label'),
      icon: 'pi pi-fw pi-home',
      to: '/',
    },
    {
      label: t('menu.features.items.projectCouncil'),
      icon: 'pi pi-fw pi-file-check',
      children: [
        {
          label: t('menu.features.items.proposalViewList'),
          icon: 'pi pi-fw pi-list',
          to: '/proposal',
        },
        {
          label: t('menu.features.items.projectProposalViewList'),
          icon: 'pi pi-fw pi-list',
          to: '/project-proposal',
        },
        {
          label: t('menu.features.items.topicViewList'),
          icon: 'pi pi-fw pi-list',
          to: '/project',
        },
        {
          label: t('menu.features.items.topicCompleted'),
          icon: 'pi pi-fw pi-list',
          to: '/project-completed',
        },
        {
          label: t('menu.features.items.pubProjectProposalViewList'),
          icon: 'pi pi-fw pi-list',
          to: '/pub-project-proposal',
        },
      ],
    },
    {
      label: t('menu.features.items.projectProposalCouncil'),
      icon: 'pi pi-fw pi-list',
      to: '/project-proposal-defense',
      activePaths: [
        '/project-proposal-defense',
        '/prequalification-review',
        '/financial-review',
        '/specialize-review',
        '/midterm-review',
        '/acceptance-review',
        'liquidation-review',
      ],
    },
    {
      label: t('menu.features.items.scientificProfile'),
      icon: 'pi pi-fw pi-id-card',
      to: '/scientific-profile',
    },
    {
      label: t('menu.features.items.scientistViewList'),
      icon: 'pi pi-fw pi-list',
      to: '/scientists',
    },
    {
      label: t('menu.features.items.docs'),
      icon: 'pi pi-fw pi-info-circle',
      children: [
        {
          label: t('menu.features.items.guideline'),
          icon: 'pi pi-fw pi-question-circle',
          to: '/guideline',
        },
        {
          label: t('menu.features.items.forms'),
          icon: 'pi pi-fw pi-file',
          to: '/forms',
        },
      ],
    },
  ];

  return (
    <nav className="layout-topbar-horizontal-menu">
      {model.map((item) =>
        item.children ? (
          <div
            key={item.label}
            className={`topbar-menu-link dropdown${isDropdownActive(item) ? ' active' : ''}`}
            ref={(el) => (dropdownRefs.current[item.label] = el)}
          >
            <button
              type="button"
              tabIndex={0}
              className="dropdown-toggle-btn"
              onClick={() => setOpenDropdown(openDropdown === item.label ? null : item.label)}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <i className={item.icon} />
              <span>{item.label}</span>
              <i className="pi pi-angle-down" style={{ marginLeft: 4 }} />
            </button>
            {openDropdown === item.label && (
              <div
                className={`dropdown-menu${
                  isDropdownActive(item) ? ' dropdown-menu-parent-active' : ''
                }`}
              >
                {item.children.map((child) => (
                  <Link
                    key={child.to}
                    to={child.to}
                    className={`dropdown-item${isActive(child.to) ? ' active' : ''}`}
                    onClick={() => setOpenDropdown(null)}
                  >
                    {child.icon && <i className={child.icon} style={{ marginRight: 8 }} />}
                    {child.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ) : (
          <Link
            key={item.to}
            to={item.to}
            className={`topbar-menu-link${isActive(item.activePaths || item.to) ? ' active' : ''}`}
          >
            <i className={item.icon} />
            <span>{item.label}</span>
          </Link>
        )
      )}
    </nav>
  );
}

export default AppTopbarMenu;
